import actions from './moduleNotificationManagementActions.js'

export default {
  isRegistered: false,
  namespaced: true,
  actions

}

